import { CloudWatchClient, PutMetricDataCommand } from '@aws-sdk/client-cloudwatch'
import { CLIENT_FACTORY } from '../factories/ClientFactory'
import { APP_CONFIG } from '../config/AppConfig'
import { Errors } from '../constants/Errors'

interface Dimension {
    readonly Name: string
    readonly Value: string
}

const DEFAULT_DIMENSIONS: Dimension[] = [
    {
        Name: 'Stage',
        Value: APP_CONFIG.getStage(),
    },
]

const NAMESPACE = 'GCL/Logins'

enum Metric {
    USER_LOGIN = 'USER_LOGIN',
    USER_LOGOUT = 'USER_LOGOUT',
    USER_LOGIN_REFRESH = 'USER_LOGIN_REFRESH',
}

export class MetricService {
    private client: CloudWatchClient | undefined

    public constructor() {
        this.client = CLIENT_FACTORY.getCloudWatchClient()
        console.log('MetricService client initialized.')
    }

    private getDimensions(email: string, dimensions: Dimension[]) {
        return [
            ...dimensions,
            {
                Name: 'User',
                Value: email,
            }
        ]
    }

    async userLogin(email: string) {
        try {
            const dimensions = this.getDimensions(email, DEFAULT_DIMENSIONS)
            await this.publish(NAMESPACE, Metric.USER_LOGIN, dimensions)
        } catch (e) {
            console.log(Errors.PUBLISH_METRIC, e)
        }
    }

    async userRefresh(email: string) {
        try {
            const dimensions = this.getDimensions(email, DEFAULT_DIMENSIONS)
            await this.publish(NAMESPACE, Metric.USER_LOGIN_REFRESH, dimensions)
        } catch (e) {
            console.log(Errors.PUBLISH_METRIC, e)
        }
    }

    async userLogout(email: string) {
        try {
            const dimensions = this.getDimensions(email, DEFAULT_DIMENSIONS)
            await this.publish(NAMESPACE, Metric.USER_LOGOUT, dimensions)
        } catch (e) {
            console.log(Errors.PUBLISH_METRIC, e)
        }
    }

    private async publish(namespace: string, metricName: string, dimensions: Dimension[]) {
        const command = new PutMetricDataCommand({
            MetricData: [
                {
                    MetricName: metricName,
                    Dimensions: dimensions,
                    Timestamp: new Date(),
                    Unit: 'None',
                    Value: 1.0,
                },
            ],
            Namespace: namespace,
        })

        await this.client!.send(command)
    }
}

export default MetricService
